module.exports = __webpack_public_path__ + "static/img/product_banner_44_zh.abc14cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_44_zh.png
// module id = R5FT
// module chunks = 34